import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const USER_LANGUAGE_SETTING_KEY = "user-language-setting";

/**
 * The language codes the picker can write. The legacy `"en"` value is never
 * written by the UI — the backend resolves it to `en-CA` / `en-US` by region.
 */
export type OutputLanguage = "en-CA" | "en-US" | "fr-ca" | "es";

/** The region the backend instance runs in. */
export type Region = "us" | "ca";

export interface UserLanguageSettingResponse {
  /**
   * The stored value, or `null` when the advisor has never changed it. May
   * still hold the legacy `"en"`, so it is not typed as `OutputLanguage`.
   */
  outputLanguage: string | null;
  /** Backend-resolved language — what the picker displays. Never null. */
  resolvedOutputLanguage: OutputLanguage;
  /** `null` when the instance region config is absent. */
  region: Region | null;
}

const FAILSAFE_LANGUAGE_SETTING: UserLanguageSettingResponse = {
  outputLanguage: null,
  resolvedOutputLanguage: "en-US",
  region: null,
};

export const getUserLanguageSetting =
  async (): Promise<UserLanguageSettingResponse> => {
    try {
      const response = await http.get<UserLanguageSettingResponse>(
        links.userLanguageSetting.index,
      );
      return response.data || FAILSAFE_LANGUAGE_SETTING;
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };

export const updateUserLanguageSetting = async (
  outputLanguage: OutputLanguage,
): Promise<UserLanguageSettingResponse> => {
  try {
    const response = await http.put<UserLanguageSettingResponse>(
      links.userLanguageSetting.index,
      { outputLanguage },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
